<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M36 7H12a2 2 0 00-2 2v30a2 2 0 002 2h24a2 2 0 002-2V9a2 2 0 00-2-2zm-1 3v22H13V10zM13 38v-4h22v4z"/><circle cx="24" cy="36" r="1"/></svg>